import { render } from "./CustomerMemoCell.vue?vue&type=template&id=c1f0ca0e&scoped=true&ts=true"
import script from "./CustomerMemoCell.vue?vue&type=script&lang=ts"
export * from "./CustomerMemoCell.vue?vue&type=script&lang=ts"

import "./CustomerMemoCell.vue?vue&type=style&index=0&id=c1f0ca0e&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f0ca0e"]])

export default __exports__